module.exports = __webpack_public_path__ + "img/logo.6e557d3.png";